import { Link } from 'react-router-dom';

function Menu() {
  return (
    <div className="menu">
        <nav>
          <ul className="horizontal-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/ourservices">Our Services</Link>
            </li>
            <li>
              <Link to="/latestnews">Blogs</Link>
            </li>
            <li>
              <Link to="/contactus">Contact Us</Link>
            </li>
          </ul>
      </nav>
    </div>
  );
}
export default Menu;